
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass('Gamification.Gamification.ChecklistNodiEditor')
    export class ChecklistNodiEditor extends Serenity.Extensions.GridEditorBase<ChecklistNodiRow, any> {
        protected getColumnsKey() { return ChecklistNodiColumns.columnsKey; }
        protected getDialogType() { return ChecklistNodiDialog; }
        protected getIdProperty() { return ChecklistNodiRow.idProperty; }
        protected getInsertPermission() { return ChecklistNodiRow.insertPermission; }
        protected getLocalTextPrefix() { return ChecklistNodiRow.localTextPrefix; }
        protected getService() { return ChecklistNodiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this,
                autoSizeAllJustOnce: false,
                useExplicitWidths: true,
                ignoreHeaders: 800,
                maxWidth: 800,
                minWidth: 800
            });

            return this.slickGrid;
        }

        protected getSlickOptions(): Slick.GridOptions {
            let opt = super.getSlickOptions();
            //opt.rowHeight = 150;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return (this.idNodo > 0);
        }

        protected getColumns() {
            var columns = super.getColumns();

            //
            if (!Q.Authorization.hasPermission("Role:SuperAdmin")) {

                // Add column
                columns.unshift({
                    field: 'Delete Row',
                    name: '',
                    format: ctx => '<a class="inline-action delete-row" title="delete">' +
                        '<i class="fa fa-trash-o text-red"></i></a>',
                    width: 24,
                    minWidth: 24,
                    maxWidth: 24
                });
            }

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
            //    // Remove Button
            //    buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            //}

            //
            buttons.push({
                title: 'Seleziona',
                hint: '',
                cssClass: 'goto-seleziona',
                icon: 'fa-list-ol',
                separator: true,
                onClick: () => { /*Add Function Here */
                    //
                    var dialogChecklistNodiPicker = new NodiPickerDialog({
                        hideNodi: this.view.getItems().map(x => x.IdNodo)
                    });
                    //
                    dialogChecklistNodiPicker.onSuccess = (selected) => {
                        // filter already existing products
                        selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdNodo == x.IdNodo));

                        for (var sel of selected) {
                            var item = <ChecklistNodiRow>{
                                IdChecklist: this.idChecklist,
                                IdNodo: sel.IdNodo,
                                IdNodoNome: sel.Nome
                            };

                            var id = this.getNextId();
                            item[this.getIdProperty()] = id;
                            this.view.addItem(item);
                        }

                        return true;
                    };
                    //
                    dialogChecklistNodiPicker.dialogOpen();
                }
            });
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Desideri eliminare il record selezionato?', () => {
                        this.view.deleteItem(item.IdChecklistNodo);
                    });
                }
            }
        }

        // /////////////////////////////////////////
        private _idChecklist: number;

        get idChecklist() {
            return this._idChecklist;
        }

        set idChecklist(value: number) {
            if (this._idChecklist != value) {
                this._idChecklist = value;
                this.setEquality(ChecklistNodiRow.Fields.IdChecklist, value);
                this.refresh();
            }
        }

        private _idNodo: number;

        get idNodo() {
            return this._idNodo;
        }

        set idNodo(value: number) {
            if (this._idNodo != value) {
                this._idNodo = value;
                this.setEquality(ChecklistNodiRow.Fields.IdNodo, value);
                this.refresh();
            }
        }
    }


}